module.exports = __webpack_public_path__ + "static/media/c11.81e4066e.jpg";